export default [
  {
    path: '/notificacao',
    name: 'Notificacao',
    component: () => import('./CotistaListNotification'),
    meta: {
      domain: 'Notificacao',
      sidebar: true,
      icon: 'notifications',
      title: 'Notificações',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Notificacoes/NotificacaoRouter.js